import { Application } from "pixi.js";
import { GameController } from "./gameController";

export interface BootstrapOptions {
  canvas?: HTMLCanvasElement;
  width?: number;
  height?: number;
  backgroundColor?: number;
}

export async function bootstrap(options: BootstrapOptions = {}): Promise<GameController> {
  const {
    canvas,
    width = window.innerWidth,
    height = window.innerHeight,
    backgroundColor = 0x1a1a2e
  } = options;

  const app = new Application();

  await app.init({
    width,
    height,
    backgroundColor,
    antialias: true,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
    resizeTo: window
  });

  if (canvas) {
    document.body.appendChild(app.canvas);
  } else {
    document.body.appendChild(app.canvas);
  }

  document.body.style.margin = "0";
  document.body.style.overflow = "hidden";
  app.canvas.style.display = "block";
  app.canvas.style.touchAction = "none";

  const controller = new GameController({ app });

  return controller;
}

export function cleanup(controller: GameController): void {
  controller.destroy();
}
